var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplacementAdvisorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.1,43.1H17.9V6.9h14.2V43.1z M19.2,41.7h11.5V8.3H19.2V41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3,8.3H16.7V6.3c0-2.2,1.8-4,4-4h8.7c2.2,0,4,1.8,4,4V8.3z M18,6.9H32V6.3c0-1.4-1.2-2.6-2.6-2.6h-8.7 c-1.4,0-2.6,1.2-2.6,2.6V6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,3.7h-6V2.4C22,1,22.7,0,23.7,0h2.6c1,0,1.7,1,1.7,2.4V3.7z M23.4,2.4h3.3c0-0.6-0.2-1-0.3-1l-2.6,0 C23.6,1.4,23.4,1.8,23.4,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3,50h-2.6c-1,0-1.7-1-1.7-2.4v-1.3h6v1.3C28,49,27.3,50,26.3,50z M23.4,47.6c0,0.6,0.2,1,0.3,1l2.6,0 c0.1,0,0.3-0.4,0.3-1H23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4,47.6h-8.7c-2.2,0-4-1.8-4-4v-1.9h16.6v1.9C33.3,45.9,31.5,47.6,29.4,47.6z M18,43.1v0.6c0,1.4,1.2,2.6,2.6,2.6h8.7 c1.4,0,2.6-1.2,2.6-2.6v-0.6H18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplacementAdvisorLogo);
export default __webpack_public_path__ + "static/media/replacement_advisor_logo.a2f1cb8896cbe366bea4c7f7684a99d0.svg";
export { ForwardRef as ReactComponent };